import { ArrowBack } from "@mui/icons-material";
import { Box, Button, Tooltip } from "@mui/material";

interface BackButtonProps {
  onClick: () => void;
  label?: string;
  showTooltip?: boolean;
}

export default function BackButton({ onClick, label = "Wróć", showTooltip = true }: BackButtonProps) {
  const button = (
    <Button
      size="small"
      onClick={onClick}
      startIcon={<ArrowBack fontSize="small" />}
      sx={{
        color: "primary.main",
        textTransform: "none",
        fontSize: { xs: "0.75rem", sm: "0.75rem" },
        padding: { xs: "4px 8px", sm: "4px 12px" },
        minWidth: "auto",
        "&:hover": {
          backgroundColor: "action.hover",
        },
        "& .MuiButton-startIcon": {
          marginRight: { xs: 0, sm: 0.5 },
        },
      }}
    >
      <Box
        component="span"
        sx={{
          display: { xs: "none", sm: "inline" },
        }}
      >
        {label}
      </Box>
    </Button>
  );

  if (showTooltip) {
    return <Tooltip title={label}>{button}</Tooltip>;
  }

  return button;
}

